/*
  KP: "RECENTLY VIEWED": a sliding row of the products this shopper has looked at,
  newest first. It shows on collection pages, under the grid of products, and on product
  pages, straight under "You may also like". It replaces the Rebuy app's "recently
  viewed" row, which was at the bottom of two of the product page layouts.

  How it works, with nothing fetched from anywhere:
    - On a PRODUCT page it notes that product (name, photo, price, address) in the
      shopper's own browser. The newest 12 are kept (cfg.keep).
    - On a COLLECTION page it draws the row from those notes, straight after the section
      that holds the product grid. A few collection layouts are built as landing pages
      with no main grid (the Winter Shop ones, for example): on those the row goes at the
      bottom of the page, above the footer. Nothing shows until the shopper has looked
      at a product.
    - On a PRODUCT page it also draws the row, under "You may also like" (or under the
      main part of the page on a layout without that row), leaving out the product being
      looked at. It only appears once the shopper has looked at at least one OTHER
      product: on a first visit nothing is added to the page at all. It is only drawn
      when the shopper scrolls near it. To switch the row off on product pages only, add
      onProduct: false  to window.KP_RECENT in snippets/theme-globals.liquid.
    - On product pages it also takes Rebuy's "recently viewed" row away (the Rebuy block
      is still in those two layouts; its empty holder is removed before Rebuy fills it,
      and the empty section around it is closed up).
  The notes stay in that browser only: they are not sent anywhere, and are not shared
  between a shopper's phone and computer. A price is noted as it was when the product was
  looked at; if the shopper has since switched currency, the row leaves prices out
  rather than show them in the old currency.

  Settings are in snippets/theme-globals.liquid (window.KP_RECENT): the title, how many
  products to keep, and the number of the Rebuy widget to take away. The cards and the
  row share their styles with "You may also like" (assets/kp-recs.css), which this file
  fetches itself when it has something to show.
  Delete the kp-recent lines in theme-globals.liquid to switch all of this off.
*/
(function () {
  'use strict';

  var cfg = window.KP_RECENT;
  if (!cfg) return;

  var KEY = 'kp-recent';

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---- Product pages: note this product, and take Rebuy's row away ----

  function note(product) {
    if (!product || !product.handle) return;
    var list = read().filter(function (item) {
      return item && item.handle !== product.handle;
    });
    list.unshift({
      handle: product.handle,
      title: product.title,
      image: product.image,
      price: product.price,
      from: !!product.from,
      currency: product.currency
    });
    write(list.slice(0, cfg.keep || 12));
  }

  function removeRebuyRow() {
    if (!cfg.rebuyWidget) return;
    var holders = document.querySelectorAll('[data-rebuy-id="' + cfg.rebuyWidget + '"]');
    for (var i = 0; i < holders.length; i++) {
      var holder = holders[i];
      if (holder.closest('#rebuy-cart')) continue;
      var section = holder.closest('.shopify-section');
      holder.parentNode.removeChild(holder);
      // Close up the section it sat in, when that section is only there to hold apps.
      if (section && section.querySelector('[data-section-type="apps"]')) section.style.display = 'none';
    }
  }

  // ---- Collection pages: the row ----

  function sized(url, width) {
    if (/([?&])width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + width);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function card(item, showPrice) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (
      '<a class="kp-recs__card" href="' + escapeHtml(root + 'products/' + item.handle) + '">' +
      '<span class="kp-recs__media">' +
      (item.image
        ? '<img src="' + escapeHtml(sized(item.image, 360)) + '" srcset="' +
          escapeHtml(sized(item.image, 240)) + ' 240w, ' + escapeHtml(sized(item.image, 360)) + ' 360w, ' +
          escapeHtml(sized(item.image, 540)) + ' 540w" sizes="(min-width: 720px) 200px, 44vw" alt="" loading="lazy" width="360" height="360">'
        : '') +
      '</span>' +
      '<span class="kp-recs__name">' + escapeHtml(item.title || '') + '</span>' +
      (showPrice && item.price
        ? '<span class="kp-recs__price">' + (item.from ? 'From ' : '') + escapeHtml(item.price) + '</span>'
        : '<span class="kp-recs__price"></span>') +
      '</a>'
    );
  }

  var ARROW =
    '<svg width="8" height="12" viewBox="0 0 8 12" aria-hidden="true"><path d="M1.5 1l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function build(list) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    var html = '';
    for (var i = 0; i < list.length; i++) {
      if (!list[i] || !list[i].handle) continue;
      html += card(list[i], !currency || !list[i].currency || list[i].currency === currency);
    }
    if (!html) return null;

    var box = document.createElement('section');
    box.className = 'kp-recs kp-recs--slide';
    box.setAttribute('aria-label', cfg.title || 'Recently viewed');
    box.innerHTML =
      '<div class="kp-recs__head">' +
      '<h2 class="kp-recs__title">' + escapeHtml(cfg.title || 'Recently viewed') + '</h2>' +
      '<div class="kp-recs__nav">' +
      '<button type="button" class="kp-recs__arrow kp-recs__arrow--back" aria-label="Back">' + ARROW + '</button>' +
      '<button type="button" class="kp-recs__arrow" aria-label="Forward">' + ARROW + '</button>' +
      '</div>' +
      '</div>' +
      '<div class="kp-recs__row">' + html + '</div>';

    var row = box.querySelector('.kp-recs__row');
    var arrows = box.querySelectorAll('.kp-recs__arrow');
    var slide = function (direction) {
      row.scrollBy({ left: direction * Math.max(200, row.clientWidth * 0.8), behavior: 'smooth' });
    };
    arrows[0].addEventListener('click', function () {
      slide(-1);
    });
    arrows[1].addEventListener('click', function () {
      slide(1);
    });

    // The arrows only show when there is more than fits.
    var check = function () {
      box.classList.toggle('has-more', row.scrollWidth > row.clientWidth + 4);
    };
    window.addEventListener('resize', check);
    box.kpCheck = check;
    return box;
  }

  // Draws the row from "list" and hands it to "put" to go on the page, once the styles
  // are there (so the row never shows undressed).
  function show(list, put) {
    if (!list.length || document.querySelector('.kp-recs--slide')) return;
    var box = build(list);
    if (!box) return;

    var placed = false;
    var place = function () {
      if (placed) return;
      placed = true;
      put(box);
      box.kpCheck();
    };

    var link = document.querySelector('link[data-kp-recs]');
    if (!cfg.css || (link && link.sheet)) {
      place();
      return;
    }
    if (!link) {
      link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cfg.css;
      link.setAttribute('data-kp-recs', '');
      document.head.appendChild(link);
    }
    link.addEventListener('load', place);
  }

  function showOnCollection() {
    // After the section with the product grid; on a layout with no grid, at the end of
    // the page's main part. Here the row keeps its own margin at the sides.
    var grid = document.querySelector('.collection__products') || document.querySelector('[data-section-type="collection"]');
    var section = grid && grid.closest('.shopify-section');
    var main = document.querySelector('main');
    if (!section && !main) return;

    show(read(), function (box) {
      box.className += ' kp-recs--page';
      if (section) {
        section.parentNode.insertBefore(box, section.nextSibling);
      } else {
        main.appendChild(box);
      }
    });
  }

  function showOnProduct(list) {
    // Straight under "You may also like", inside the same part of the page so the two
    // rows line up. On a layout without that row: under the main part of the product
    // page, with the row's own margin at the sides.
    var recs = document.querySelector('.kp-recs');
    var under = recs && (recs.closest('.shopify-app-block') || recs);
    var main = document.querySelector('.main-product-section');
    var anchor = under || main;
    if (!anchor) return;

    var go = function () {
      show(list, function (box) {
        if (!under) box.className += ' kp-recs--page';
        anchor.parentNode.insertBefore(box, anchor.nextSibling);
      });
    };

    // Only when the shopper is getting near it.
    if (!('IntersectionObserver' in window)) {
      go();
      return;
    }
    var watcher = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            watcher.disconnect();
            go();
            return;
          }
        }
      },
      { rootMargin: '1200px 0px' }
    );
    watcher.observe(anchor);
  }

  function run() {
    if (cfg.page === 'product') {
      // The products looked at before this one (this one is left out of its own row).
      var current = cfg.product && cfg.product.handle;
      var others = read().filter(function (item) {
        return item && item.handle && item.handle !== current;
      });
      note(cfg.product);
      removeRebuyRow();
      if (cfg.onProduct !== false && others.length) showOnProduct(others);
    } else if (cfg.page === 'collection') {
      showOnCollection();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
